import { AbstractIntlMessages } from "next-intl";
import merge from "lodash/merge";
import { languageConfig } from "./language-config";
import { removeEmptyTranslations } from "../utils/i18n/translation-utils";

export async function loadServerTranslations(locale: string, namespaces: string[]): Promise<AbstractIntlMessages> {
  const locales = languageConfig.getLocales();
  const defaultLocale = languageConfig.getDefaultLocale();
  const validatedLocale = (locales as string[]).includes(locale) ? locale : defaultLocale;
  const needsFallback = validatedLocale !== defaultLocale;

  const messages: AbstractIntlMessages = {};

  for (const namespace of namespaces) {
    try {
      let defaultTranslations = {};
      if (needsFallback) {
        try {
          defaultTranslations = (await import(`locales/${defaultLocale}/${namespace}.json`)).default;
        } catch (error) {
          console.warn(`Failed to load default locale "${defaultLocale}" for namespace "${namespace}"`);
        }
      }

      const localeTranslations = (await import(`locales/${validatedLocale}/${namespace}.json`)).default;
      const cleanedTranslations = removeEmptyTranslations(localeTranslations);

      messages[namespace] = needsFallback ? merge({}, defaultTranslations, cleanedTranslations) : cleanedTranslations;
    } catch (error) {
      console.error(`Failed to load namespace "${namespace}" for locale "${validatedLocale}":`, error);
      messages[namespace] = {};
    }
  }

  return messages;
}
